export default "__VITE_ASSET__CPGLLY$f__"